import { useV2GetSurveyByIdQuery } from "@generated";
import { Survey } from "../types";

const useGetSurvey = ({ id }: { id: number }) => {
  const { data, isLoading, isFetching, refetch } = useV2GetSurveyByIdQuery({
    id: String(id),
    include: ["survey-responses", "survey-recommendations"],
  });

  let survey: Survey | null = null;

  if (data?.data) {
    survey = {
      id: String(id),
      name: data.data?.attributes.name || "",
      responses: data.data?.attributes?.responses || [],
      calculations: data.data?.attributes?.calculations || [],
    };
  }
  return {
    survey,
    surveyLoading: isLoading,
    surveyFetching: isFetching,
    surveyRefetch: refetch,
  };
};

export default useGetSurvey;
